import React from 'react'

export default function RadioGroupField({
  label,
  name,
  options, // Array of { label, value } or object { displayLabel: value }
  defaultValue,
  value,
  onChange,
  error,
  className = '',
  inline = true
}) {
  const isControlled = value !== undefined
  const currentValue = isControlled ? value : defaultValue

  // Normalize options to array format
  const normalizedOptions = Array.isArray(options)
    ? options
    : Object.entries(options).map(([displayLabel, val]) => ({
        label: displayLabel,
        value: val
      }))

  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue)
    }
  }

  return (
    <div className={`mb-4 ${className}`}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className={inline ? 'flex flex-wrap gap-4' : 'space-y-2'}>
        {normalizedOptions.map(({ label: optionLabel, value: optionValue }) => (
          <label key={optionValue} className="inline-flex items-center cursor-pointer">
            <input
              type="radio"
              name={name}
              value={optionValue}
              checked={isControlled ? currentValue === optionValue : undefined}
              defaultChecked={!isControlled && currentValue === optionValue}
              onChange={() => handleChange(optionValue)}
              className="w-4 h-4 text-brand-light focus:ring-brand-light border-gray-300"
            />
            <span className="ml-2 text-sm text-gray-700">{optionLabel}</span>
          </label>
        ))}
      </div>
      {error && (
        <div className="mt-1 text-red-600 text-sm">{error}</div>
      )}
    </div>
  )
}
